import React from "react";
import { useSelector as useReduxSelector } from "react-redux";
import BreadcrumbPills, {
    BreadcrumbPillsProps,
} from "web/react/components/feeds-filters/feeds-filter-breadcrumb-pills/feeds-filter-breadcrumb-pills";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { ReduxStoreState } from "web/redux/store";
import { gettext } from "web/script/modules/django-i18n";
import styles from "./feeds-filter-bar.module.css";

interface FeedsFilterBarProps {
    breadcrumbs: BreadcrumbPillsProps["breadcrumbs"];
    onFilterClick(): void;
}

function FeedsFilterBar({ breadcrumbs, onFilterClick }: FeedsFilterBarProps): null | JSX.Element {
    const loading = useReduxSelector((state: ReduxStoreState) => state.feedSidebarReducer.loading);

    return (
        <div className={styles.wrapper}>
            <div className={styles.scrollableWrapper}>
                <BreadcrumbPills breadcrumbs={breadcrumbs} className={styles.pills} />
            </div>
            <span role="presentation" className={styles.divider} />
            <button
                className={styles.filterButton}
                onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                    e.preventDefault();
                    onFilterClick();
                }}
                disabled={loading}
                aria-label={gettext("feed.filter.mobile_btn_text")}
            >
                <SVGIcon name="filters" className={styles.svgIcon} />
            </button>
        </div>
    );
}

export default FeedsFilterBar;
